import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import Api from 'api';
import * as Common from 'common/components';
import { custodyVoucherPreview } from 'lib/pdfs/autosur';
import {
  VOUCHER_FORMATS,
  autosurRecordFromAsset,
  downloadIndividualVoucher,
  individualFormat,
  saveSignedCopy,
  signIndividualVoucher,
} from 'lib/vouchers';

/**
 * Per-asset custody voucher of the asset detail, in the client's format
 * (lib/vouchers/clientConfig): sign and save it, or download it for paper.
 * The signed PDF goes to POST .../assets/:assetId/custody_vouchers.
 * AUTOSUR has its HTML preview (Common.AutosurVoucherPreview: a PDF in an
 * <iframe> does not show on Android Chrome); the other formats show who signs
 * and the asset.
 */
export class CustodyVoucherModal extends PureComponent {
  static propTypes = {
    show: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    onSaved: PropTypes.func.isRequired,
    format: PropTypes.string.isRequired,
    canSign: PropTypes.bool,
    asset: PropTypes.object.isRequired,
    company: PropTypes.object.isRequired,
    subcompany: PropTypes.object.isRequired,
    user: PropTypes.object,
    locations: PropTypes.array,
    error: PropTypes.func,
    success: PropTypes.func,
    t: PropTypes.func.isRequired,
  };

  static defaultProps = { canSign: true };

  ctx = () => ({
    company: this.props.company,
    subcompany: this.props.subcompany,
    t: this.props.t,
    user: this.props.user,
    locations: this.props.locations,
  });

  handlePaper = (withPrice) =>
    downloadIndividualVoucher(this.props.format, this.props.asset, this.ctx(), { withPrice });

  handleSign = async (signatureImage, withPrice) => {
    const { asset, company, subcompany, user, format } = this.props;
    const { blob, fileName } = await signIndividualVoucher(
      format,
      asset,
      this.ctx(),
      signatureImage,
      user,
      { withPrice }
    );
    await Api.assets.addCustodyVoucher(asset.id, company.id, subcompany.id, blob, fileName);
    saveSignedCopy(blob, fileName); // only once the back saved it
  };

  renderAutosurPreview = () => {
    const { asset, subcompany, user } = this.props;
    return (
      <Common.AutosurVoucherPreview
        preview={custodyVoucherPreview(autosurRecordFromAsset(asset, this.ctx()), {
          subcompany: subcompany && subcompany.name,
          user,
        })}
      />
    );
  };

  renderPreview = () => {
    const { asset, format } = this.props;
    if (format === VOUCHER_FORMATS.AUTOSUR) return this.renderAutosurPreview();
    const employee = asset._employee || {};
    return (
      <Common.VoucherSummary
        custodian={[employee.name, employee.lastname].filter(Boolean).join(' ')}
        position={employee.position}
        assets={[asset]}
      />
    );
  };

  render = () => (
    <Common.SignVoucherModal
      show={this.props.show}
      handleClose={this.props.handleClose}
      title={this.props.t('actions.custodyVoucher')}
      preview={this.renderPreview()}
      priceOption={individualFormat(this.props.format).price}
      canSign={this.props.canSign}
      onPaper={this.handlePaper}
      onSign={this.handleSign}
      onSaved={this.props.onSaved}
      error={this.props.error}
      success={this.props.success}
    />
  );
}

export default translate()(CustodyVoucherModal);



// WEBPACK FOOTER //
// src/modules/secured/modules/fixedassets/components/detail/CustodyVoucherModal.js